export const checkIsSellAvalible = progress => {
  return !!progress && progress.length > 0
    ? progress.find(
        e =>
          (e.code === 1002 && e.is_active === true) ||
          (e.code === 2002 && e.is_active === true)
      )
    : null
}
